import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Heading } from 'components/UIComponents/Typography/index.js';

import { formatDateTime } from 'utils/dateUtils';
import {
  submissionStatuses,
  submissionUploadGeneralStatuses,
} from 'utils/constants/submissionConstants';
import './style.scss';

export default () => {
  const { t } = useTranslation();

  const {
    submissionDetail: { submissionHistoryDtos = [], submissionUploadDtos = [] },
  } = useSelector(state => state.submissionDetail);

  return (
    <>
      <Heading subtitle className="is-uppercase fw-bold">
        {t('datagate.external.submissionDetail.subtitle.submissionHistory')}
      </Heading>
      <div className="submission-history">
        {submissionUploadDtos.length > 0 &&
          submissionUploadDtos.map(upload => <UploadBlock {...upload} />)}
      </div>
      <Heading subtitle className="is-uppercase fw-bold">
        {t('datagate.external.submissionDetail.subtitle.newDeadlines')}
      </Heading>
        <span>{t('datagate.external.submissionDetail.subtitle.description')}</span>
      <div className="submission-history">
        {submissionHistoryDtos.length > 0 &&
          submissionHistoryDtos.map(history => (
            <SubmissionHistoryBlock {...history} />
          ))}
      </div>
    </>
  );
};

const SubmissionHistoryBlock = ({
  changerFirstName,
  changerLastName,
  dueDate,
  status,
  submissionChangedField,
}) => {
  const { t } = useTranslation();
  const deadlineChanger = `${changerFirstName} ${changerLastName}`;
  const isDueDate = submissionChangedField === 'DUE_DATE';
  const historyLabel = isDueDate
    ? t('datagate.external.submissionDetail.history.newDueDate')
    : t('Staatus muudetud');

  return (
    <>
      <div className="submission-history--block">
        <span>{`${historyLabel}, ${deadlineChanger}`}</span>
        {isDueDate ? (
          <span>{dueDate && formatDateTime(dueDate)}</span>
        ) : (
          <span className={`status--${submissionStatuses[status].color}`}>
            {'Suletud'}
          </span>
        )}
      </div>
      <hr className="submission-history--block__divider" />
    </>
  );
};

const UploadBlock = ({
  firstName,
  lastName,
  generalStatus,
  uploadStartedAt,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="submission-history--block">
        <span>
          {`${t('datagate.external.submissionDetail.history.uploaded', {
            firstName,
            lastName,
          })}. `}
          {
            <span
              className={submissionUploadGeneralStatuses[generalStatus].color}
            >
              {t(submissionUploadGeneralStatuses[generalStatus].text)}
            </span>
          }
        </span>
        <span>{uploadStartedAt && formatDateTime(uploadStartedAt)}</span>
      </div>
      <hr className="submission-history--block__divider" />
    </>
  );
};
